export default __webpack_public_path__ + "static/media/logo.8889224b.svg";